<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="loading_mask">
        <div class="circle-loader">
            <div class="circle-loader__wrap">
                <div class="left-wrap">
                    <div class="circle-loader-inside"></div>
                </div>
                <div class="right-wrap">
                    <div class="circle-loader-inside"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>

<style lang="less" scoped>
.loading_mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
.circle-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border: 1px solid #fff;
    border-radius: 20px;
}
.circle-loader__wrap {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -18px 0 0 -18px;
    width: 36px;
    height: 36px;
    /* background-color: #fff; */
    border-radius: 20px;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
}

.circle-loader__wrap div {
    overflow: hidden;
    position: absolute;
    width: 50%;
    height: 100%;
}
.circle-loader__wrap .circle-loader-inside {
    position: absolute;
    left: 100%;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 1000px;
    background: #fff;
    -webkit-animation: loading-left 2.5s linear;
    animation: loading-left 2.5s linear;
}
.circle-loader__wrap .left-wrap {
    left: 0;
}
.circle-loader__wrap .left-wrap .circle-loader-inside {
    z-index: 1;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    -webkit-transform-origin: 0 50% 0;
    transform-origin: 0 50% 0;
    -webkit-animation: loading-left 2.5s linear;
    animation: loading-left 5s linear;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}
.circle-loader__wrap .right-wrap {
    left: 50%;
}
.circle-loader__wrap .right-wrap .circle-loader-inside {
    z-index: 1;
    left: -100%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    -webkit-transform-origin: 100% 50% 0;
    transform-origin: 100% 50% 0;
    -webkit-animation: loading-right 2.5s linear;
    animation: loading-right 5s linear;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}

@keyframes loading-left {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    100% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}

@keyframes loading-right {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(180deg);
        transform: rotate(170deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/loading.vue